import React, { useMemo } from 'react';
import { Image } from 'react-native';
import { createStyleSheet, UnistylesRuntime, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../services/window-information';

function getLogo() {
    const isSmartSampa = useMemo(() => window.location.hostname.includes('smartsampa'), [window.location]);
    const { isMobileOrTablet } = WindowInformation();

    if (isSmartSampa) {
        if (isMobileOrTablet) {
            if (UnistylesRuntime.themeName === 'dark') {
                return require('../../assets/big_smartsampa_logo_mobile_dark.png');
            } else {
                return require('../../assets/big_smartsampa_logo_mobile_light.png');
            }
        } else {
            if (UnistylesRuntime.themeName === 'dark') {
                return require('../../assets/big_smartsampa_logo_dark.png');
            } else {
                return require('../../assets/big_smartsampa_logo_light.png');
            }
        }
    }
    if (UnistylesRuntime.themeName === 'dark') {
        return require('../../assets/SentinelX_logo_dark.png');
    } else {
        return require('../../assets/SentinelX_logo_light.png');
    }
}

export default function SentinelXLogo() {
    const { styles } = useStyles(stylesheet);
    return <Image style={styles.image} source={getLogo()} />;
}

const stylesheet = createStyleSheet(() => ({
    image: {
        width: '100%',
        resizeMode: 'contain',
        height: '100%',
    },
}));
